import React, { Component } from 'react';
import { connect } from "react-redux";
import actions from 'store/actions';
import { Pie, Bar } from '@ant-design/plots';
import { LoadingOverlay, DataObjectConsentList } from "components";
import { showError, showSuccess } from 'common/ToastNotifications';
import AppPaths from 'constants/appPaths';
import { withRouter } from "react-router";
import { Row, Col, Carousel, Card, Switch, Space } from 'antd';
import ReactDOM from 'react-dom';
import _ from 'lodash';

class DataObjectConsents extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fetchingRecords: false,
            busy: false,
            busyMessage: "Please wait..."
        }
    }

    componentWillMount() {
        this.setState({
            fetchingRecords: true
        });
        this.props.getDataObjectConsents(this.props.dataObjectId);
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetDataObjectConsentsResultChanged(prevProps);
    }

    onGetDataObjectConsentsResultChanged = (prevProps) => {
        if (this.props.getDataObjectConsentsResult && this.props.getDataObjectConsentsResult !== prevProps.getDataObjectConsentsResult) {
            if (!this.props.getDataObjectConsentsResult.success) {
                showError("Unable to get consents.");
            }
            this.setState({
                fetchingRecords: false
            });
        }
    }

    isBusy = () => {
        let isBusy = this.state.busy || this.state.fetchingRecords;
        return isBusy;
    }

    render() {
        return <Row style={{ background: "#fffff", overflowY: "auto", width: "100%", height: "100%" }} className="layout-row">
            <Col span={24} style={{ display: "flex", flexDirection: "column", flexWrap: "nowrap" }}>
                <LoadingOverlay
                    busy={this.isBusy()}
                    spinner
                    message={this.state.busyMessage || "Please wait..."}>
                </LoadingOverlay>
                {
                    !this.isBusy()
                        ?
                        <DataObjectConsentList consentList={this.props.dataObjectConsents}></DataObjectConsentList>
                        :
                        <></>
                }
            </Col>
        </Row>
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getDataObjectConsentsResult: state.dataObjectVerification.getDataObjectConsentsResult,
        dataObjectConsents: state.dataObjectVerification.dataObjectConsents
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getDataObjectConsents: (dataObjectId) => dispatch(actions.getDataObjectConsentsRequest(dataObjectId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DataObjectConsents));